import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "pk_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const adminMe = () => axios.get(`${API}/auth/me`, authHeader()).then((r) => r.data);

export const adminStats = () => axios.get(`${API}/admin/stats`, authHeader()).then((r) => r.data);

export const adminOrders = (status) =>
  axios.get(`${API}/admin/orders${status ? `?status=${status}` : ""}`, authHeader()).then((r) => r.data);

export const adminContacts = () =>
  axios.get(`${API}/admin/contacts`, authHeader()).then((r) => r.data);

export const adminRevenueMonthly = () =>
  axios.get(`${API}/admin/revenue-monthly`, authHeader()).then((r) => r.data);

export const hubListVideos = () =>
  axios.get(`${API}/admin/hub/videos`, authHeader()).then((r) => r.data);

export const hubUploadVideo = (formData, onProgress) =>
  axios
    .post(`${API}/admin/hub/videos`, formData, {
      ...authHeader(),
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((r) => r.data);

export const hubDeleteVideo = (id) =>
  axios.delete(`${API}/admin/hub/videos/${id}`, authHeader()).then((r) => r.data);

export const slidesList = (entity, params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  ).toString();
  return axios.get(`${API}/admin/slides/${entity}${qs ? `?${qs}` : ""}`, authHeader()).then((r) => r.data);
};

export const slidesCreate = (entity, data) =>
  axios.post(`${API}/admin/slides/${entity}`, data, authHeader()).then((r) => r.data);

export const slidesDelete = (entity, id) =>
  axios.delete(`${API}/admin/slides/${entity}/${id}`, authHeader()).then((r) => r.data);


export const slidesImport = (file, dryRun, mode = "producten") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("dry_run", dryRun ? "true" : "false");
  fd.append("import_mode", mode);
  return axios.post(`${API}/admin/slides-import`, fd, authHeader()).then((r) => r.data);
};

export const koppelOverzicht = () =>
  axios.get(`${API}/admin/koppelingen/overzicht`, authHeader()).then((r) => r.data);

export const koppelProducten = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  ).toString();
  return axios.get(`${API}/admin/koppelingen/producten${qs ? `?${qs}` : ""}`, authHeader()).then((r) => r.data);
};

export const koppelAnalyse = () =>
  axios.post(`${API}/admin/koppelingen/analyse`, {}, authHeader()).then((r) => r.data);

export const koppelRun = (runId) =>
  axios.get(`${API}/admin/koppelingen/runs/${runId}`, authHeader()).then((r) => r.data);

export const koppelUitvoeren = (runId) =>
  axios.post(`${API}/admin/koppelingen/${runId}/uitvoeren`, {}, authHeader()).then((r) => r.data);

export const koppelHerstel = (runId) =>
  axios.post(`${API}/admin/koppelingen/${runId}/herstel`, {}, authHeader()).then((r) => r.data);

export const koppelHandmatig = (data) =>
  axios.post(`${API}/admin/koppelingen/koppel`, data, authHeader()).then((r) => r.data);

// --- AI-teksten (concepten voor ontbrekende vormteksten)
export const aiTekstenOverzicht = () =>
  axios.get(`${API}/admin/ai-teksten/overzicht`, authHeader()).then((r) => r.data);
export const aiTekstenGenereer = (limiet) =>
  axios.post(`${API}/admin/ai-teksten/genereer`, { limiet }, authHeader()).then((r) => r.data);
export const aiTekstenJob = (jobId) =>
  axios.get(`${API}/admin/ai-teksten/jobs/${jobId}`, authHeader()).then((r) => r.data);
export const aiTekstenGoedkeuren = (data) =>
  axios.post(`${API}/admin/ai-teksten/goedkeuren`, data, authHeader()).then((r) => r.data);
export const aiTekstenAfkeuren = (data) =>
  axios.post(`${API}/admin/ai-teksten/afkeuren`, data, authHeader()).then((r) => r.data);


export const slidesUpdate = (entity, id, data) =>
  axios.put(`${API}/admin/slides/${entity}/${id}`, data, authHeader()).then((r) => r.data);


export const downloadInvoice = async (sessionId, filename) => {
  const res = await axios.get(`${API}/admin/orders/${sessionId}/invoice`, {
    ...authHeader(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "factuur.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadPackingSlip = async (sessionId, filename) => {
  const res = await axios.get(`${API}/admin/orders/${sessionId}/packing-slip`, {
    ...authHeader(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "verzendbon.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadLabel = async (sessionId, filename) => {
  const res = await axios.get(`${API}/admin/orders/${sessionId}/label`, {
    ...authHeader(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "label.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const regenerateLabel = (sessionId) =>
  axios.post(`${API}/admin/orders/${sessionId}/label/regenerate`, {}, authHeader()).then((r) => r.data);

export const fmtEuro = (n) =>
  new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("nl-BE", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
};
